import axios from 'axios';

export interface VideoAuthor {
  username: string;
  profile_url: string;
  verified: boolean;
  followers?: number;
}

export interface VideoTag {
  name: string;
}

export interface VideoItem {
  id: number;
  url: string;
  description: string;
  music_title: string;
  date: string;
  likes: number;
  comments: number;
  shares: number | null;
  bookmarks: number;
  views: number | null;
  author: VideoAuthor;
  tags: VideoTag[];
}

export interface VideosResponse {
  data: VideoItem[];
  total: number;
}

export const fetchVideos = async (skip: number = 0, limit: number = 12, sort_by: string = 'newest'): Promise<VideosResponse> => {
  const response = await axios.get('/api/videos/', {
    params: { skip, limit, sort_by}
  });
  return response.data;
};